import axiosInstance from '../../../../config/axiosInstance';
const ProjectCategoryService = {
    async GetAllProjectCategories(ProjectID, redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, SearchColumns) {
        try {
            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "";
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetProjectCategory?ProjectID=${ProjectID}&ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async DeleteProjectCategory(projectId, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteProjectCategory?ID=${projectId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetDefaultProjectCategory(ID, ProjectID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/SetDefaultProjectCategory?ID=${ID}&ProjectID=${ProjectID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default ProjectCategoryService;